import React from 'react';
import Select from 'react-select';
import { selectStyles, selectTheme } from './SelectStyles';
import { SelectOption } from './SingleSelect';
import './select-portal-styles.css';

interface MultiSelectProps {
  name: string;
  options: SelectOption[];
  placeholder: string;
  onChange: (selectedOptions: any) => void;
  className?: string;
  width?: string;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  name,
  options,
  placeholder,
  onChange,
  className = "text-sm",
  width = "w-80"
}) => {
  return (
    <div className={`relative ${width} select-container 
      [--select-bg:white] 
      dark:[--select-bg:rgb(31,41,55)] 
      [--select-text:rgb(17,24,39)] 
      dark:[--select-text:rgb(243,244,246)] 
      [--select-border:rgb(156,163,175)] 
      dark:[--select-border:rgb(75,85,99)] 
      [--select-hover:rgb(243,244,246)] 
      dark:[--select-hover:rgb(55,65,81)] 
      [--select-active:rgb(219,234,254)] 
      dark:[--select-active:rgb(55,65,81)] 
      [--select-multi-bg:rgb(219,234,254)] 
      dark:[--select-multi-bg:rgb(55,65,81)] 
      [--select-multi-text:rgb(30,58,138)] 
      dark:[--select-multi-text:rgb(243,244,246)] 
      [--select-placeholder:rgb(107,114,128)] 
      dark:[--select-placeholder:rgb(156,163,175)]`}>
      <Select
        isMulti
        name={name}
        options={options}
        className={`${className} select-component`}
        classNamePrefix="select"
        placeholder={placeholder}
        onChange={onChange}
        styles={selectStyles}
        theme={selectTheme}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

export default MultiSelect; 